<template>
  <v-row>
    <v-col cols="12" lg="10" offset-lg="1">
      <v-breadcrumbs divider=">" :items="breadcrumbs" class="pl-1 pb-3" />
      <v-card class="mb-1">
        <v-card-title class="theme">
          <v-icon class="white--text">keyboard</v-icon>
          <span class="headline ml-2 white--text"
            >Edit backoffice document</span
          >
          <v-spacer />
          <v-btn depressed @click="dialog = true" class="error rounded-sm"
            >delete</v-btn
          >
        </v-card-title>
        <v-divider />
        <v-card-text>
          <v-form ref="form" v-model="formValidation">
            <v-container>
              <v-row>
                <v-col cols="12" lg="6">
                  <v-text-field
                    label="Name*"
                    :rules="[validationRules.required]"
                    persistent-hint
                    hint="Name of the backoffice Document"
                    v-model="backoffice.name"
                  />
                </v-col>
                <v-col cols="12" lg="6">
                  <v-autocomplete
                    label="Type"
                    persistent-hint
                    hint="Select a category or use general"
                    :items="types"
                    :rules="[validationRules.required]"
                    item-text="name"
                    item-value="value"
                    v-model="backoffice.type"
                  />
                </v-col>
                <v-col cols="12" lg="12">
                  <div class="my-5 ">
                    <ckeditor
                      :editor="editor"
                      :config="editorConfig"
                      v-model="backoffice.description"
                      style="min-height: 300px !important"
                    />
                  </div>
                </v-col>
              </v-row>
              <v-btn
                depressed
                class="save white--text rounded-sm mt-5 mx-7"
                @click="save"
                >Save</v-btn
              >
            </v-container>
          </v-form>
        </v-card-text>
      </v-card>
    </v-col>
    <v-dialog v-model="dialog" persistent max-width="400">
      <v-card>
        <v-card-title class="headline pt-4">
          <v-spacer />
          <span>Are you sure?</span>
          <v-spacer />
        </v-card-title>
        <v-divider />
        <v-card-text class="my-3 text-xs-center"
          >You will not be able to undo this operation.</v-card-text
        >
        <v-divider />
        <v-card-actions>
          <v-btn color="success" text @click="dialog = !dialog">cancel</v-btn>
          <v-spacer />
          <v-btn color="error" text @click="deleteItem">delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar" :bottom="true" :right="true">
      {{ snackbarMessage }}
      <v-btn color="pink" text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </v-row>
</template>

<script>
import BalloonEditor from "@ckeditor/ckeditor5-editor-balloon/src/ballooneditor";
import {mapGetters} from "vuex";

import {Actions} from "@/views/actions";
import {Breadcrumbs} from "@/views/breadcrumbs";
import {Component} from "@/views/component";
import {Constants} from "@/views/constants";

export default {
  name: Component.Protected.Backoffice.Edit,
  data: () => ({
    editor: BalloonEditor,
    breadcrumbs: Breadcrumbs.Backoffice.Edit,
    backoffice: {
      type: "",
      name: "",
      description: "",
      visibility: "",
    },
    modal: false,
    dialog: false,
    types: Constants.BackOffice.Types.Obj,
    formValidation: true,
    editorConfig: {},
  }),
  computed: {
    ...mapGetters(["userInfo"]),
  },
  methods: {
    save() {
      if (this.$refs.form.validate()) {
        let payload = {
          id: this.$route.params.id,
          data: {
            name: this.backoffice.name,
            description: this.backoffice.description,
            type: this.backoffice.type,
          },
        };

        this.$store
          .dispatch(Actions.Backoffice.Edit, payload)
          .then(() => {
            this.$router.push({ name: Component.Protected.Backoffice.List });
          })
          .catch((e) => {
            console.error(Constants.BackOffice.Messages.Error.Edit, e);
            this.snackbarMessage = Constants.BackOffice.Messages.Error.Edit;
            this.snackbar = true;
          });
      }
    },
    deleteItem() {
      if (!this.validRole() || !this.$route.params.id) {
        return false;
      }
      this.$store
        .dispatch(Actions.Backoffice.Delete, this.$route.params.id)
        .catch((e) => {
          console.error(Constants.BackOffice.Messages.Error.Delete, e);
          this.snackbar = true;
          this.snackbarMessage = Constants.BackOffice.Messages.Error.Delete;
        })
        .finally(() =>
          this.$router.push({ name: Component.Protected.Backoffice.List })
        );
    },
    setup() {
      if (this.userInfo.role !== Constants.Roles.HR && this.userInfo.role !== Constants.Roles.Manager) {
        this.$router.go(-1)
      } else {
        this.$store.dispatch(Actions.Backoffice.Get, this.$route.params.id).then((r) => {
          this.backoffice = {...r.data};
        }).catch((e) => {
          console.error(Constants.BackOffice.Messages.Error.Get, e);
          this.snackbar = true;
          this.snackbarMessage = Constants.BackOffice.Messages.Error.Get;
        });
      }
    },
    validRole(){
      return this.userInfo.role === Constants.Roles.Manager ||
          this.userInfo.role === Constants.Roles.HR
    }
  },
  created() {
    if (!this.$route.params.id) {
      this.$router.go(-1);
      return false;
    }
    if (this.userInfo && this.userInfo.role) {
      this.setup();
    } else {
      this.$store.dispatch(Actions.Firebase.UserInfo).then(() => this.setup());
    }
    this.editorConfig = this.editorConfigBackoffice;
  },
};
</script>
<style>
* >>> div.v-picker__title {
  background-color: #551738 !important;
  border-color: #551738 !important;
}

* >>> div.v-date-picker-table {
  height: 200px !important;
}
.ck.ck-editor__editable > .ck-placeholder::before {
  color: lightgray !important;
}
.ck.ck-editor__editable_inline > :first-child {
  margin-top: var(--ck-spacing-large);
  padding-bottom: var(--ck-spacing-large) !important;
  font-family: Roboto Slab;
}
.ck.ck-editor__editable_inline > :last-child {
  margin-top: var(--ck-spacing-large);
}
.ck-content {
  color: #272929;
  padding: 2rem !important;
}
.ck-focused {
  border: thin solid lightgray !important;
  outline: none !important;
  box-shadow: none !important;
}
@media (max-width: 768px) {
    .ck-content:h1 {
        font-size: 20px;
    }
    .ck-content:h2{
      font-size: 18px
    }
    .ck-content{
      padding:0.5rem!important;
    }
}
@media (min-width: 769px) and (max-width: 1024px) {
    .ck-content:h1 {
        font-size: 22px;
    }
    .ck-content.ck-content:h2{
      font-size: 20px;
    }
}
</style>